import '../styles/Contact.css';
import { CONTACT_DATA } from '../constants/data';

function Contact() {
  const { info, hours } = CONTACT_DATA;

  return (
    <section id="contact" className="contact-section">
      <div className="contact-content">
        <h2>Contact Us</h2>
        <div className="contact-info">
          <div className="contact-details">
            <h3>Get in Touch</h3>
            <p><i className="fas fa-phone"></i> Phone: {info.phone}</p>
            <p><i className="fas fa-envelope"></i> Email: {info.email}</p>
            <p><i className="fas fa-map-marker-alt"></i> Address: {info.address}</p>
            <p><i className="fa-brands fa-instagram"></i> <button className='insta-button' onClick={() => window.open("https://www.instagram.com/tastyjunctionottawa/")}>Instagram</button></p>
            <div className="hours">
              <h3>Opening Hours</h3>
              <p>{hours.weekdays}</p>
              <p>{hours.weekends}</p>
              <p>{hours.sunday}</p>
              <p>{hours.closed}</p>
            </div>
          </div>
          {/* <form className="contact-form">
            <input type="text" placeholder="Your Name" />
            <input type="email" placeholder="Your Email" />
            <input type="tel" placeholder="Your Phone" />
            <textarea placeholder="Your Message"></textarea>
            <button type="submit">Send Message</button>
          </form> */}
        </div>
      </div>
    </section>
  );
}

export default Contact;
